





































import Vue from "vue";
import { mapState, mapActions } from "vuex";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {};
  },
  props: {
    column: {},
    row: {},
    hover: {
      type: Boolean
    }
  },
  computed: {
    ...mapState("appModule", {
      user: "loggedInUser"
    })
  },
  inject: ["actionHandler", "activeTab"],
  methods: {
    handleTableClick(type: "request" | "edit") {
      this.actionHandler(type, this.row);
    },
    handleRowItemClick(event: Event) {
      event.stopPropagation();
      this.actionHandler("rowselect", this.row);
    }
  }
});
